'use client';

import { VixRuleValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: VixRuleValues;
  onValuesChange: (field: keyof VixRuleValues, value: number) => void;
  translations: ToolsTranslations['vixRule'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleInputChange = (value: string) => {
    const normalized = value.replace(',', '.');
    const num = parseFloat(normalized);
    if (!isNaN(num) && num >= 0) {
      onValuesChange('vixLevel', num);
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4 text-blue-500 animate-pulse" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v4a1 1 0 002 0V7zm-1 8a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" clipRule="evenodd" />
            </svg>
            <label htmlFor="vix-input" className="text-gray-700 font-medium">{translations.vixLevel}</label>
          </div>
          <div className="flex items-center gap-2">
            <input
              id="vix-input"
              type="text"
              value={new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(values.vixLevel)}
              onChange={(e) => handleInputChange(e.target.value)}
              className="w-36 text-right border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100 px-3 py-2 text-gray-800 font-semibold bg-white shadow-sm"
              aria-label={translations.vixLevel}
            />
          </div>
        </div>
        <div className="relative">
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-green-500 h-2 rounded-full transition-all duration-300"
              style={{ width: `${Math.min((values.vixLevel / 80) * 100, 100)}%` }}
            ></div>
          </div>
          <input
            id="vix-slider"
            type="range"
            min="5"
            max="80"
            step="0.05"
            value={values.vixLevel}
            onChange={(e) => onValuesChange('vixLevel', parseFloat(e.target.value))}
            className="absolute inset-0 w-full h-2 cursor-pointer slider"
            aria-label={`${translations.vixLevel} slider`}
          />
        </div>
        <div className="flex justify-between text-xs text-gray-500">
          <span>5</span>
          <span>80</span>
        </div>
      </div>

      <style jsx>{`
        .slider::-webkit-slider-thumb {
          appearance: none;
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background: #10b981;
          cursor: pointer;
          border: 2px solid #ffffff;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        .slider::-moz-range-thumb {
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background: #10b981;
          cursor: pointer;
          border: 2px solid #ffffff;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
      `}</style>
    </div>
  );
}


